import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../user.service';
import { GlobalEventMangerService } from '../global-event-manger.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LocalstorageService } from '../localstorage.service';
import { EchexpaymentService } from '../echexpayment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptService } from '../script.service';
import { Constants } from '../app.constants';
import {  ViewChild, ElementRef, Renderer2  } from '@angular/core';

declare var Plaid: any;

@Component({
  selector: 'app-login-authentication',
  templateUrl: './login-authentication.component.html',
  styleUrls: ['./login-authentication.component.css']
})
export class LoginAuthenticationComponent implements OnInit, OnDestroy {
  public VerifyPhoneModel : boolean = true;
  public connectbank : boolean = false;
  verifyPhone: any = {};
  busy: Subscription;
  public phoneNumber : string;
  public countrycode : number;
  public confirm_countrycode : number;
  public confirmPhoneNumber : number;
  public PhoneOtpcheck : string;
  public Steptwo : boolean = false;
  public Stepthree : boolean = false;
  public Stepfour : boolean = false;
  public Stepfive : boolean = false;
  public showUploadDiv = false;
  public planSectionopen = false;
  profileBankDetails: any = {};
  public formTouched : boolean = false;
  linkHandler: any;
  public disable:boolean=false;
  public chequeerror_res:string;
  public tokenj:string;
  public bankname:string;
	public bankaddress:string;
	public bankcity:string;
  public bankzip:string;
  public plaid_public_key :string;
  public plaid_link_key :string = 'casherpay';
  public key:string;
  public plaid_public_token :string;
  public ptoken : any = {};
  public account_checking : string;
  public routing_checking : string;
	public token: string;
  public user_id: string;
  public merchantId: string;
  public getDoc_List : any = [];
  public CreatedDoc : any = [];
  public uploadedDocs: number[] = [];
  public overall_steps : any = {};
  public doc_dataNotFound: boolean=false;
  public CheckOtp: boolean=false;
  public userFirstName : string;
  public userLastName : string;
  public mask: Array<string | RegExp>;
  @ViewChild('submitButton') submitButton: ElementRef;
  @ViewChild('otpInput') otpInput: ElementRef;

  constructor(protected userService :UserService, private elementRef: ElementRef, private renderer: Renderer2, private scriptService :ScriptService,private CONSTANTS: Constants, private router: Router, private route: ActivatedRoute, private toastr: ToastrService, protected localStorageService: LocalstorageService, private echexpaymentService :EchexpaymentService,private globalEventMangerService: GlobalEventMangerService) { 
    this.mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    let currentUser = <any>{};
    currentUser = this.localStorageService.getData("currentUser");
    this.merchantId = currentUser && currentUser.merchant_token; 


   
     this.phoneNumber = currentUser && currentUser.phone;
     if (typeof this.phoneNumber === 'string') {
       const digitsOnly = this.phoneNumber.replace(/\D/g, ''); // Remove non-digit characters
       const lastFourDigits = digitsOnly.substr(-4);
       this.phoneNumber = '******' + lastFourDigits;
     }
     

     this.countrycode = currentUser && currentUser.country_code;
     this.confirm_countrycode = currentUser && currentUser.country_code;
    //  this.confirmPhoneNumber = currentUser && currentUser.phone;
     this.userFirstName = currentUser && currentUser.first_name;
		 this.userLastName = currentUser && currentUser.last_name;

     this.plaid_public_key = CONSTANTS.plaid_public_key;
		this.key = CONSTANTS.captcha_key;
    let currentToken = <any>{};
    currentToken = this.localStorageService.getData("currentUserToken");
    if(currentToken && currentToken.data.is_steps_completed) {
      this.router.navigate(['/dashboard']);
    }
    if(this.localStorageService.getData("currentUserToken")){
      this.token = currentToken.data.user_token;
    }
		
     this.user_id = currentUser && currentUser._id;
  }

  ngOnDestroy() {
    this.toastr.clear();
  }

  ngOnInit() {
     this.getDocument_type();
     this.getVerifyStep();
  }

  
  moveNext(nextInput: HTMLInputElement, checkbox) {
    if(checkbox === 2){
        const saveButton = document.getElementById('submitButton') as HTMLElement;
        if (saveButton) {
          saveButton.focus();
          saveButton.click();
        }
      } else if(checkbox === 3){
        const saveButton = document.getElementById('submitOTP') as HTMLElement;
        if (saveButton) {
          saveButton.focus();
          saveButton.click();
        }
      } else{
        nextInput && nextInput.focus();
      }
}

  ngAfterViewInit(){
    this.renderer.selectRootElement('#FocusInitial').focus();
    setTimeout(() => {
      this.renderer.selectRootElement('#FocusInitial').focus();
    }, 100); 
    
		this.scriptService.load('Plaid').then(data => {
			this.loadPopUp();
		}).catch(error => console.log(error));
	}

  // loadPopUp
    loadPopUp = async () => {
    let data = {"user_token" : this.token};
    let responseData = <any>{};
    this.busy =  this.userService.ConectBankV2(data).subscribe(
      response => {
          responseData = response;
          this.plaid_link_key = responseData.data.link_token;   
          this.linkHandler =  Plaid.create({
            token: this.plaid_link_key,
            onSuccess: function(public_token, metadata) {
            ((document.getElementById("publictoken") as HTMLInputElement).value) = public_token;
                var l = document.getElementById('submitToGetInfo');
                l.click(); 
            },
            onExit: function(err, metadata) {
              // The user exited the Link flow.
              if (err != null) {
              
              }
            }
          });
      },
      error => {
          console.log(error)
      }
    );
   
 }
 
  focusFirstInvalidControlPlus(): void {
    const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
    if (firstElementWithErrors) {
      firstElementWithErrors.focus();
    }
  }

  VerifyPhoneNumber(verifyphonedata, action: string){
    this.focusFirstInvalidControlPlus();   //focus field
    if(verifyphonedata.valid){
          let phoneNumber = verifyphonedata.value.confirm_phone_number;
          let formattedPhoneNumber = phoneNumber.replace(/\D/g, '');
          if(action === 'send_otp') {
                let data = {
                  "otp_method" : "sms",
                  "confirm_phone_number" : verifyphonedata.value.confirm_countrycode + formattedPhoneNumber,
                  "user_token" : this.token
                };
                let registerData = <any>{}; 
                this.busy =  this.userService.VerifyPhone_Number(data).subscribe(
                  response => {
                      registerData = response;
                      
                      if(registerData.status_code === 500){
                        this.PhoneOtpcheck = registerData.message;
                      } else{
                        this.toastr.success(registerData.message, 'Success!');
                        this.PhoneOtpcheck = '';
                        this.otpInput.nativeElement.focus();
                      }
                  },
                  error => {
                      registerData = error;
                      this.PhoneOtpcheck = error.message;
                  }
                );
          } else{

            if (verifyphonedata.value.otp_text.length >= 4 && verifyphonedata.value.otp_text.length <= 6) {
              this.CheckOtp = false;
            } else {
                this.CheckOtp = true;
                const saveButton = document.getElementById('otpFocus') as HTMLElement;
                if (saveButton) {
                  saveButton.focus();
                  saveButton.click();
                }
                return
            }
         
             this.CheckOtp = false;
              let data = {
                "otp_text" : verifyphonedata.value.otp_text,
                "confirm_phone_number" : verifyphonedata.value.confirm_countrycode + formattedPhoneNumber,
                "user_token" : this.token
              };
              let registerData = <any>{}; 
              this.busy =  this.userService.VerifyPhone_NumberOTP(data).subscribe(
                response => {
                    registerData = response;
                    if(registerData.status_code === 500){
                      this.PhoneOtpcheck = registerData.message;
                    } else{
                      this.Steptwo = true;
                      this.VerifyPhoneModel = !this.VerifyPhoneModel;
                      this.connectbank = !this.connectbank;
                      this.toastr.success(registerData.message, 'Success!');
                      this.PhoneOtpcheck = '';
                    }
                },
                error => {
                    registerData = error;
                    this.PhoneOtpcheck = error.message;
                }
              );
          }
    }
  }

  updateOtp(inputElement: HTMLInputElement) {
    const inputValue = inputElement.value.trim(); // Remove leading/trailing whitespace
    if (inputValue.length >= 4 && inputValue.length <= 6) {
      this.CheckOtp = false;
    } else {
      this.CheckOtp = true;
    }
  }
  
  
  

  UploadDocument(){
    // this.showUploadDiv = !this.showUploadDiv;
  }



  	// Open Plaid popup
  	ConnectBank(){
      this.formTouched = true;
      this.linkHandler.open();
  
  }

// get info from Plaid
  getInfoFromPlaid(){
       
  var public_token = ((document.getElementById("publictoken") as HTMLInputElement).value);
    var data = {
        PlaidInfo :true,
        token :public_token,
        // token: "link-sandbox-eabb99a8-11eb-4f36-8f55-0bcb77116bcf",
        amount : 1,
    }
    let responseData = <any>{};
    this.busy = this.echexpaymentService.getInfoFromPlaidApi(data).subscribe(
       response => {
          this.disable = true;
          responseData = response;
          this.profileBankDetails = responseData; 
          this.account_checking = responseData.data.account_checking;
          this.routing_checking = responseData.data.routing_checking;
          this.getRoutingInfo(responseData.data.routing_checking);
       },
       error => {
            responseData = error;
            this.account_checking = '';
            this.routing_checking = '';
            this.bankname = '';
            this.bankaddress = '';
            this.chequeerror_res = responseData.error.message;
       }
     );
  }


    // get routing info
    getRoutingInfo(routing_number){
      if(routing_number.length >=9)
      {
      let data = {
        user_token: this.token,
        token: this.user_id,
        id: this.user_id,
        routing_number:routing_number
      }
      let responseData = <any>{};
      this.userService.getRoutingInfoApi(data).subscribe(
            response => {
              responseData = response;
              this.chequeerror_res = '';
              this.bankname = responseData.data.name;
              this.bankaddress = responseData.data.address;
              this.toastr.success('Bank Added Successfully', '');
            }, 
            error => {
              responseData = error;
              this.account_checking = '';
              this.routing_checking = '';
              this.bankname = '';
              this.bankaddress = '';
              this.chequeerror_res = error.message;
            }
      ); 
    }
  }

  
    // save bank details
    saveBankDetails(data){
    if(data.valid){
        let model = data.value; 
        model.user_token = this.token;
        model.token = this.user_id;
        model.id = this.user_id;
        let response_save = <any>{};
        this.busy = this.userService.saveBankDetailwithoutsign(model).subscribe(
          response => {
              response_save = response;
              this.showUploadDiv = !this.showUploadDiv;
              this.toastr.success(response_save.message, '');
              this.connectbank = !this.connectbank;
              this.Stepthree = true;
          },
          error => {
            response_save = error;
            this.chequeerror_res = error.message;
          }
        );
    }
  }


  // Document uploadFile
	getDocument_type() {
		let data = {
		  user_token:this.token,
		}
		let responseData = <any>{};
		this.busy = this.userService.GetDocumentType(data).subscribe(
		   response => {
			  responseData = response;
          this.getDoc_List = responseData;
		   },
		   error => {
			    responseData = error;
		   }
		);
  }
 
  // uploadFile docu
  uploadFile(files: FileList, lookupKey: string, index: number) {
    if (files.length === 0) {
      return;
    }
  
    const allowedFileTypes = [
      'image/jpeg',
      'image/png',
      'text/csv', // CSV
      'image/webp',
      'application/msword', // DOC
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
      'application/pdf',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // Excel (XLSX)
    ];
    

    const file = files[0];
    if (!allowedFileTypes.includes(file.type)) {
      this.chequeerror_res = 'Only files with the following extensions are allowed: jpg, png, csv, jpeg, webp, doc, docx, pdf, excel';
      setTimeout(() => {
        this.chequeerror_res = '';
      }, 8000); // Hide error message after 5 seconds
      return;
    }

    
    let data = {
      "merchantId": this.merchantId,
      "user_token": this.token,
    };
  
    let filedata = {
      "document_lookup_type": lookupKey
    };
  
    
    const formData = new FormData();
    formData.append('document', file, file.name);
  
    Object.entries(filedata).forEach(([key, value]) => {
      formData.append(key, value as any);
    });
  
    let uploadlastmonthData = <any>{};
    this.busy = this.userService.LastMonthStatementUpload(data, formData).subscribe(
      response => {
        uploadlastmonthData = response;
        this.chequeerror_res = '';
        this.uploadedDocs.push(index);
        if(this.uploadedDocs.length === 7){
          this.Stepfour = true;
          setTimeout(() => {
            this.showUploadDiv = false;
            this.planSectionopen = true;
           // this.router.navigate(['/get-started-plan']);
          }, 5000); 
        } else{
          this.getDocument_List();
        }
        this.toastr.success(uploadlastmonthData.message, 'Success!');
      },
      error => {
        uploadlastmonthData = error;
        this.chequeerror_res = error.message;
        this.toastr.error(error.message, 'Failed!');
      }
    );
  }
  
    // Document uploadFile
	getVerifyStep() {
		let data = {
		  user_token:this.token,
		}
		let responseData = <any>{};
		this.busy = this.userService.GetVerifySteps(data).subscribe(
		   response => {
			  responseData = response;
          this.overall_steps = responseData.data;
             //Find step 
              if (!responseData.data.phone) {
                this.Steptwo = false;
                this.VerifyPhoneModel = true;
              } else if(!responseData.data.bank){
                this.connectbank = true;
                this.Steptwo = true;
                this.VerifyPhoneModel = false;
              } else if(!responseData.data.document){
                this.getDocument_List();
                this.showUploadDiv = true;
                this.Stepthree = true;
                this.Steptwo = true;
                this.VerifyPhoneModel = false;
                this.connectbank = false;
              } else if(!responseData.data.plan){
                this.Stepfour = true;
                this.Steptwo = true;
                this.Stepthree = true;
                this.VerifyPhoneModel = false;  // true
                this.getDocument_List();
                this.showUploadDiv = false;
                this.connectbank = false;
                this.planSectionopen = true;
                //  this.router.navigate(['/get-started-plan']);
              }
		   },
		   error => {
			    responseData = error;
		   }
		);
  }

    // Document List 
	getDocument_List() {
		let data = {
		  user_token:this.token,
		  merchantId:this.merchantId,
		}
		let responseData = <any>{};
		 this.userService.GetDocumentList(data).subscribe(
		   response => {
			  responseData = response;
          this.CreatedDoc = responseData.data;
          if(responseData.data.length === 7){
            setTimeout(() => {
              this.planSectionopen = true;
              this.Stepfour = true;
              this.showUploadDiv = false;
            }, 5000); 
          }

          if(responseData.data.length == 0){
            this.doc_dataNotFound =  responseData.message
         }
		   },
		   error => {
			    responseData = error;
		   }
		);
  }

  isDescriptionInCreatedDoc(description: string): boolean {
    return this.CreatedDoc.some(item => item.lookup_description === description);
  }
  SelectPlanstep(){
    this.router.navigate(['/get-started-plan']);
  }

  // force download file
  downloadFile(url, name){
    fetch(url)
      .then(resp => resp.blob())
      .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          // the filename you want
          a.download = name;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
      })
      .catch(() => alert('An error sorry'));
  }

  // Logout link
	logOut(){
		let currentUser = this.localStorageService.getData("currentUserToken");
    let token =  currentUser.data.user_token;
		this.userService.userLogout(token).subscribe(
			response => {
				console.log('User logout successfully');
			}
		);
		this.localStorageService.removeData('currentUser');
    this.localStorageService.removeData('currentUserToken');
    this.localStorageService.removeData('super_admin_detail');
		this.localStorageService.removeData('super_admin_token');
		this.localStorageService.removeData("Profile_image")
		this.localStorageService.removeData('Mer_Profile_image');
		this.globalEventMangerService.ghostLogin(false);
		this.localStorageService.removeData('merchantAdmin');
		let merchantAdmin = this.localStorageService.getData("merchantAdmin");
		this.globalEventMangerService.showNavBar(false);
		this.router.navigate(['/login']);
	}
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/login-authentication/login-authentication.component.ts